import React from "react"

import { SvgIcon } from "@mui/material"

export const CheckIcon = props => {

    return (
        <SvgIcon {...props}>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4701 0.195262C11.7305 0.455612 11.7305 0.877722 11.4701 1.13807L4.80344 7.80474C4.54309 8.06509 4.12098 8.06509 3.86063 7.80474L0.527293 4.4714C0.266944 4.21106 0.266944 3.78894 0.527293 3.5286C0.787643 3.26825 1.20975 3.26825 1.4701 3.5286L4.33203 6.39052L10.5273 0.195262C10.7876 -0.0650874 11.2098 -0.0650874 11.4701 0.195262Z" />
        </SvgIcon>
    )
}

export default CheckIcon


